export default __webpack_public_path__ + "static/media/logo_foot.e2eaa72d.png";